import { ChangeDetectorRef, Component, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ChangeReviewDetailsComponent } from 'app/modules/change-review/components/change-review-details/change-review-details.component';
import { AppIcons } from 'app/modules/shared/app.icons';
import { AppSettings } from 'app/modules/shared/app.settings';
import { LoaderService } from 'app/modules/shared/components/loader/loader.service';
import { MITableComponent } from 'app/modules/shared/components/mi-table/mi-table.component';
import { ModuleHeaderComponent } from 'app/modules/shared/components/module-header/module-header.component';
import { AccessProviderDirective } from 'app/modules/shared/directives/access-provider.directive';
import { Country } from 'app/modules/shared/models/country';
import { EntityCountsResponse, EntityList, EntityType } from 'app/modules/shared/models/entity.models';
import { Language } from 'app/modules/shared/models/language';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { ConfigService } from 'app/modules/shared/services/config.service';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
import { PermissionAccessService } from 'app/modules/shared/services/permission-access.service';
import { RestApiService } from 'app/modules/shared/services/rest-api.service';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TabViewModule } from 'primeng/tabview';
import { forkJoin } from 'rxjs';
import * as _ from 'lodash';
import { ListResponse } from 'app/modules/shared/models/listResponse.models';
import { Column } from 'app/modules/shared/components/mi-table/models/table';

@Component({
  selector: 'app-audit-logs-list',
  standalone: true,
  imports: [BreadcrumbModule, ModuleHeaderComponent, TabViewModule, TranslateModule, MITableComponent, MITableComponent, AccessProviderDirective, ChangeReviewDetailsComponent],
  templateUrl: './audit-logs-list.component.html',
  styleUrl: './audit-logs-list.component.scss'
})
export class AuditLogsListComponent implements OnInit {

  @ViewChild(MITableComponent) tableRef: MITableComponent;
  routePath: MenuItem[] = [];
  showImportExportBtn: boolean = false;
  miIcons = AppIcons;
  activeIndex: number = 0;
  isEntity: boolean = false;
  uniqueId: string = 'audit_logs_grid';
  filterList;
  btnLabel: string;
  items: MenuItem[] | undefined;
  isShowMenu: boolean = true;
  attributeLabels = {};
  filterAttributeLabels = {};
  listColumns: any;
  allColumns: any;
  pagination: any;
  totalRecords: number = 0;
  tableData: any = [];
  buttons: any[] = [];
  country: Country;
  language: Language;
  entityCount: EntityCountsResponse;
  itemsPerPage: number;
  deleteProductMsg: string;
  deleteProductHeaderMsg: string;
  showMenu: boolean = false;
  moduleHeaderSecondaryBtnMenuItems: MenuItem[] = [];
  filterFieldsArray: any[];
  isReady: boolean = false;
  attributeData: any;
  data;
  filterAvailableColumns = [];
  selectedColumns!: Column[];
  bulkSelectionsItems: MenuItem[] | undefined;
  currentRow;
  visiblePrintLabel: boolean = false;
  showBulkUpdateDialog: boolean = false;
  visible: boolean = false;
  bulkUpdateHeader;
  reviewHeader: any;
  btnUpdate: any;
  entityCreatedAtAttributeId;
  regionGeofences: any = [];
  zoneIds: any = [];
  productStatusAttributeId: string;
  entityData: EntityList;
  isLoading = true;
  advanceFilterAttributeCodes = ['start_date', 'end_date'];
  defaultFilterValues: any = {};
  labelData = {
    attributeLabels: [
      { labelKey: 'audit_logs_grid.fields.eventStatus.placeholder', labelValue: 'Event Status' },
      { labelKey: 'audit_logs_grid.fields.eventStatus.label', labelValue: 'Event Status' }
    ]
  };

  constructor(private auditLogService: EntityService,
    private cs: CommonBindingDataService, private confirmationService: ConfirmationService,
    private router: Router, private messageService: MessageService, private actRoute: ActivatedRoute,
    private metaDataService: MetaDataService,
    private restApiService: RestApiService,
    private configService: ConfigService, private permissionAccessService: PermissionAccessService,
    private cd: ChangeDetectorRef, private loaderService: LoaderService,
  ) { }

  ngOnInit() {
    this.initializeLabels();
    this.initializeColumn();
    this.initializeOtherVariablesAndAPI();
    this.btnLabel = this.cs.getLabel('audit_logs.lbl_export');
    this.setDefaultDateFilter();
    this.getData();
  }


  initEntityPayload() {
    this.entityData = {
      limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
      offset: 0,
      searchStr: "",
      defaultSortColumn: "updatedAt",
      defaultSortType: "desc",
      eventCode: "",
      forTenantCode: this.configService.getForTenantCode(),
      data: [],
      filters: [],
      statusCode: "",
      startDate: "",
      endDate: "",
      entityCode: [],
    };
  }

  initializeColumn() {
    this.allColumns = [
      {
        "attributeCode": "Id",
        "attributeIndex": 0,
        "field": "Id",
        "header": this.cs.getLabel('audit_logs.lbl_id'),
        "isSortable": true
      },
      {
        "attributeCode": "firstName",
        "attributeIndex": 1,
        "field": "firstName",
        "header": this.cs.getLabel('audit_logs.lbl_first_name'),
        "isSortable": true
      },
      {
        "attributeCode": "lastName",
        "attributeIndex": 2,
        "field": "lastName",
        "header": this.cs.getLabel('audit_logs.lbl_last_name'),
        "isSortable": true
      },
      {
        "attributeCode": "entityType",
        "attributeIndex": 3,
        "field": "entityType",
        "header": this.cs.getLabel('audit_logs.lbl_entity_type'),
      },
      {
        "attributeCode": "eventStatus",
        "attributeIndex": 4,
        "field": "eventStatus",
        "header": this.cs.getLabel('audit_logs.lbl_event_status'),
      },
      {
        "attributeCode": "createdAt",
        "attributeIndex": 5,
        "field": "createdAt",
        "header": this.cs.getLabel('audit_logs.lbl_created_at'),
        "isSortable": true
      },
    ];
  }

  initializeOtherVariablesAndAPI() {
    this.btnLabel = this.cs.getLabel('change_review.lbl_change_reviews');
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
    this.initEntityPayload();
  }

  setDefaultDateFilter() {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    // Use today as maximum date (include today's data)
    const today = new Date();

    // For current month, use today as end date, otherwise use last day of month or today (whichever is earlier)
    let endDate;
    if (currentDate.getMonth() === new Date().getMonth() && currentDate.getFullYear() === new Date().getFullYear()) {
      // Current month: use today
      endDate = new Date(today);
    } else {
      // Previous month: use last day of that month or today, whichever is earlier
      endDate = lastDayOfMonth < today ? lastDayOfMonth : today;
    }

    firstDayOfMonth.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    this.entityData.startDate = this.metaDataService.setDateFilterOffset(firstDayOfMonth.getTime());
    this.entityData.endDate = this.metaDataService.setDateFilterOffset(endDate.getTime());

    this.defaultFilterValues = {
      Date: [firstDayOfMonth, endDate]
    };
  }

  validateDateRange(startDate: Date, endDate: Date): boolean {
    if (!startDate || !endDate) {
      return false;
    }

    const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays <= 31;
  }

  setAdvanceFilter(key, value) {
    if (value) {
      if (key === 'start_date') {
        this.entityData.advanceFilters.push({
          attributeId: this.filterList.find(ele => ele.attributeCode === key)?.attributeId,
          fromValue: new Date(<string>value).getTime(),
          comparisonOperator: AppSettings.COMPARISON_OPERATOR.GTE
        })
      } else if (key === 'end_date') {
        this.entityData.advanceFilters.push({
          attributeId: this.filterList.find(ele => ele.attributeCode === key)?.attributeId,
          fromValue: new Date(<string>value).getTime(),
          comparisonOperator: AppSettings.COMPARISON_OPERATOR.LTE
        })
      }
    }
  }

  onPageChange(event) {
    this.entityData.offset = event?.first;
    this.entityData.limit = event?.rows;
    this.searchEntity();
  }

  getData() {
    return forkJoin({
      tableViewData: this.getTableView(),
      filterViewDate: this.getFilterView(),
    })
  }

  getTableView() {
    this.isLoading = false;
    this.searchEntity();
    this.filterAvailableColumns = _.clone(this.allColumns);
    this.isEntity = false;
  }

  onSearchValueChanges(event) {
    this.entityData.searchStr = event;
    this.searchEntity();
  }

  getFilterView() {
    this.filterAttributeLabels = this.cs.getAttributeLabels(this.labelData) as unknown as Record<string, string>;
    const entityTypeValues = Object.entries(EntityType).map(([key, value]) => ({
      labelKey: key,
      labelValue: value
    }));
    this.filterList = [
      {
        "attributeCode": "entityType",
        "attributeIndex": 0,
        "presetValues": entityTypeValues,
      },
      {
        "attributeCode": "eventStatus",
        "attributeIndex": 4,
        "inputCode": "selectDropdown",
        "presetValues": [
          {
            "labelKey": "Success",
            "labelValue": "Success",
          },
          {
            "labelKey": "Error",
            "labelValue": "Error",
          },
        ],
      },
      {
        "attributeCode": "Date",
        "attributeIndex": 2,
        "inputCode": "dateRange",
        "restrictToToday": true
      },
    ];
  }

  searchEntity() {
    this.entityData.countryCode = AppSettings.HEADER_COUNTRY_CODE;
    this.loaderService.hide();
    this.auditLogService.searchEntityAuditLogs(AppSettings.ENTITY_CODE.AUDIT_LOGS, this.entityData, false).subscribe((res: ListResponse) => {
      this.listColumns = res?.data[0]?.values;
      this.pagination = res?.pagination;
      this.totalRecords = res?.count;
      this.tableData = res.data.map(data => ({
        Id: `${data.serialId}`,
        entityType: `${data.entityCode}`,
        eventStatus: `${data.statusCode}`,
        createdAt: data.loggedAt,
        ...data
      }));
      this.loaderService.hide();
    })
  }

  initializeLabels() {
    this.routePath = [{ label: this.cs.getLabel('audit_logs.lbl_audit_log'), routerLink: 'audit-logs' }];
  }

  onExportAuditLog() {
    delete this.entityData.data;
    delete this.entityData.filters;
    this.entityData.limit = 0;

    this.auditLogService.exportAuditLogs(AppSettings.ENTITY_CODE.AUDIT_LOGS,this.entityData,this.tableRef.selectedColumns);
  }

  itemPerPageChange(event) {
    this.itemsPerPage = event;
    this.entityData.limit = this.itemsPerPage;
    this.searchEntity();
  }


  onFilterValueChange(event) {
    delete this.entityData.entityCode;
    delete this.entityData.startDate;
    delete this.entityData.endDate;
    delete this.entityData.statusCode;

    for (const [key, value] of Object.entries(event)) {
      if (value) {
        const attributeValue = Array.isArray(value) ? value : [value];
        if (key === 'entityType') {
          this.entityData.entityCode = attributeValue;
        } else if (key === 'Date') {
          const fromDate = attributeValue[0];
          const toDate = attributeValue[1];

          if (fromDate && toDate) {
            const fromDateObj = fromDate instanceof Date ? fromDate : new Date(fromDate);
            const toDateObj = toDate instanceof Date ? toDate : new Date(toDate);

            if (!this.validateDateRange(fromDateObj, toDateObj)) {
              this.messageService.add({
                severity: 'error',
                summary: this.cs.getLabel('audit_logs.error_invalid_date_range_summary'),
                detail: this.cs.getLabel('audit_logs.error_date_range_max_31_days')
              });
              return;
            }

            fromDateObj.setHours(0, 0, 0, 0);
            toDateObj.setHours(23, 59, 59, 999);

            if (!isNaN(fromDateObj.getTime()) && !isNaN(toDateObj.getTime())) {
              this.entityData.startDate = this.metaDataService.setDateFilterOffset(fromDateObj.getTime());
              this.entityData.endDate = this.metaDataService.setDateFilterOffset(toDateObj.getTime());
            }
          } else {
            this.messageService.add({
              severity: 'warn',
              summary: this.cs.getLabel('audit_logs.warning_incomplete_date_range_summary'),
              detail: this.cs.getLabel('audit_logs.warning_both_dates_required')
            });
            return;
          }
        } else if (key === 'eventStatus') {
          if (attributeValue[0] === 'Success') {
            this.entityData.statusCode = 200;
          } else {
            this.entityData.statusCode = 400;
          }
        }
      }
    }

    if (!this.entityData.startDate || !this.entityData.endDate) {
      this.setDefaultDateFilter();
    }

    if (!this.entityData.entityCode || this.entityData.entityCode.length === 0) {
      delete this.entityData.entityCode;
    }
    if (!this.entityData.statusCode) {
      delete this.entityData.statusCode;
    }
    this.entityData.offset = event.first || 0;
    this.searchEntity();
  }

  onSortData(event) {
      this.entityData.defaultSortColumn = event.attributeIndex;
      this.entityData.defaultSortType = (event.sortOrder === 1) ? AppSettings.ASC_SORT_ORDER : AppSettings.DESC_SORT_ORDER;
      this.searchEntity();
  }

}
